import React from 'react';
import { Button, Card, Text } from '@fragments';
import { IconGauge } from '@tabler/icons-react';
import './styles.scss';

const SEGMENTS = 32;
const FILLED = 22;

export default function CreditScore() {
    return (
        <Card
            flat
            headerDivider
            title="Credit Score"
            icon={<IconGauge />}
            action={
                <Button variant="text" color="inverse" size="small">
                    Details
                </Button>
            }
        >
            <div className="credit-score">
                <div className="credit-score__copy">
                    <Text.h5 weight={500} contrast={10}>Your credit score is 710</Text.h5>
                    <Text.span contrast={6}>This score is considered to be Excellent.</Text.span>
                </div>

                <span className="credit-score__mood" aria-hidden="true">😎</span>

                <div
                    className="credit-score__meter"
                    role="meter"
                    aria-valuenow={710}
                    aria-valuemin={300}
                    aria-valuemax={850}
                    aria-label="Credit score 710"
                >
                    {Array.from({ length: SEGMENTS }).map((_, index) => (
                        <span
                            key={index}
                            className={index < FILLED ? 'credit-score__seg credit-score__seg--filled' : 'credit-score__seg'}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
}
